module.exports = __webpack_public_path__ + "img/N347-1.92bd0d1b.png";